import { render, staticRenderFns } from "./myMdCmp.vue?vue&type=template&id=14b0cb7a&scoped=true&"
import script from "./myMdCmp.vue?vue&type=script&lang=js&"
export * from "./myMdCmp.vue?vue&type=script&lang=js&"
import style0 from "./myMdCmp.vue?vue&type=style&index=0&id=14b0cb7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b0cb7a",
  null
  
)

export default component.exports